// Copyright (c) 2017 Deere & Company

import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import {getCurrentFiscalYear} from '../report-services/get-current-fiscal-year';
import t from 'tcomb';

const Criteria = t.struct({
    fiscalYear: t.maybe(t.Number),
    territories: t.list(DealerHierarchyTerritory)
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        fiscalYear: getCurrentFiscalYear(),
        territories: []
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/audit-summary/state/criteria.js